import { render } from "./TeamBuildingBlog.vue?vue&type=template&id=63066904&scoped=true"
import script from "./TeamBuildingBlog.vue?vue&type=script&lang=js"
export * from "./TeamBuildingBlog.vue?vue&type=script&lang=js"

import "./TeamBuildingBlog.vue?vue&type=style&index=0&id=63066904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63066904"]])

export default __exports__